export const templateMenuDef = [
    {
        "name": "patient_template_assessment",
        "resource": "patient_template_assessment",
        "icon": "fa fa-plus-square",
        "url": "patient_template_assessment",
        "check_permission": false,
        "auto_crud": true,
        "breadcrumb": "emr",
    },
    {
        name: 'menu.template_field',
        resource: 'templateField',
        icon: 'fa fa-file-text-o',
        url: 'templateField',
        auto_crud: true,
        breadcrumb: 'Template Field'
    },
    {
        name: 'menu.template_block',
        resource: 'templateBlock',
        icon: 'fa fa-file-text-o',
        url: 'templateBlock',
        auto_crud: true,
        breadcrumb: 'Template Block'
    },
    {
        name: 'menu.template',
        resource: 'template',
        icon: 'fa fa-file-text-o',
        url: 'template',
        auto_crud: true,
        breadcrumb: 'Template'
    },
    {
        name: 'menu.pullable_master',
        resource: 'pullable_master',
        icon: 'fa fa-file-text-o',
        url: 'pullable_master',
        auto_crud: true,
        breadcrumb: 'Pullable Master'
    },
    {
        name: 'menu.pushable_master',
        resource: 'pushable_master',
        icon: 'fa fa-file-text-o',
        url: 'pushable_master',
        auto_crud: true,
        breadcrumb: 'Pushable Master'
    },
    {
        name: 'menu.pullable_response',
        resource: 'pullable_response',
        icon: 'fa fa-file-text-o',
        url: 'pullable_response',
        auto_crud: true,
        breadcrumb: 'Pullable Response'
    },
    {
        name: 'menu.pullable_response_array',
        resource: 'pullable_response_array',
        icon: 'fa fa-file-text-o',
        url: 'pullable_response_array',
        auto_crud: true,
        breadcrumb: 'Pullable Response Array'
    },
    {
        name: 'menu.macros',
        resource: 'account_defined_macro',
        icon: 'fa fa-h-square',
        url: 'account_defined_macro',
        breadcrumb: "Macro",
        auto_crud: true
    },
    {
        name: 'menu.system_seriesPattern',
        resource: 'system_seriesPattern',
        icon: 'fa fa-h-square',
        url: 'system_seriesPattern',
        breadcrumb: "System SeriesPattern",
        auto_crud: true
    },
    {
        name: 'menu.system_templateField',
        resource: 'system_templateField',
        icon: 'fa fa-h-square',
        url: 'system_templateField',
        breadcrumb: "System SeriesPattern",
        auto_crud: true
    },
    {
        name: 'menu.system_template',
        resource: 'system_template',
        icon: 'fa fa-h-square',
        url: 'system_template',
        breadcrumb: "System SeriesPattern",
        auto_crud: true
    },
    {
        name: 'menu.system_templateBlock',
        resource: 'system_templateBlock',
        icon: 'fa fa-h-square',
        url: 'system_templateBlock',
        breadcrumb: "System SeriesPattern",
        auto_crud: true
    },
    {
        name: 'menu.imageMaster',
        resource: 'imageMaster',
        icon: 'fa fa-file-text-o',
        url: 'imageMaster',
        auto_crud: true,
        breadcrumb: 'Image Master'
    },
    {
        name: 'menu.imageMaster',
        resource: 'image_annotation',
        icon: 'fa fa-file-text-o',
        url: 'image_annotation',
        auto_crud: true,
        breadcrumb: 'Image Master'
    },
    {
        name: 'menu.templateBuilder',
        resource: 'template-builder',
        icon: 'fa fa-h-square',
        url: 'template-builder',
        breadcrumb: "TemplateBuilder",
        auto_crud: false
    },
    {
        name: 'menu.assessmentTemplateBuilder',
        resource: 'assessment_template',
        icon: 'fa fa-h-square',
        url: 'assessment_template',
        breadcrumb: "Assessment Template",
        auto_crud: false
    },
    {
        name: 'menu.templateConfigurationMapping',
        resource: 'template_configuration_mapping',
        icon: 'fa fa-h-square',
        url: 'template_configuration_mapping',
        breadcrumb: "template_configuration_mapping",
        auto_crud: true
    },
    {
        "name": "menu.consent_layout",
        "resource": "consent_layout",
        "icon": "fa fa-tag",
        "url": "consent_layout",
        "auto_crud": true,
        "breadcrumb": "Consent Layout Master"
    }, 
    {
        name: 'menu.template_high_level_request_master',
        resource: 'high_level_request_master',
        icon: 'fa fa-h-square',
        url: 'high_level_request_master',
        breadcrumb: "high_level_request_master",
        auto_crud: true
    },
    {
        name: 'menu.template_user_level_mapping',
        resource: 'template_user_level_mapping',
        icon: 'fa fa-h-square',
        url: 'template_user_level_mapping',
        breadcrumb: "template_user_level_mapping",
        auto_crud: true
    },
    {
        name: 'menu.level_tat_mapping',
        resource: 'level_tat_mapping',
        icon: 'fa fa-h-square',
        url: 'level_tat_mapping',
        breadcrumb: "level_tat_mapping",
        auto_crud: true
    },
    {
        name: 'menu.feedback_worklist',
        resource: 'feedback_worklist',
        icon: 'fa fa-h-square',
        url: 'feedback_worklist',
        breadcrumb: "feedback_worklist",
        auto_crud: true
    },
    {
        name: 'menu.consent_management',
        resource: 'consent_management',
        icon: 'fa fa-h-square',
        url: 'consent_management',
        breadcrumb: "consent_management",
        auto_crud: true
    },
    {
        name: 'menu.data_privacy_consent_history',
        resource: 'data_privacy_consent_history',
        icon: 'fa fa-h-square',
        url: 'data_privacy_consent_history',
        breadcrumb: "data_privacy_consent_history",
        auto_crud: true,
        check_permission: false,
        showMenu: false
    },
    {
        name: 'menu.clinical_consent_history',
        resource: 'clinical_consent_history',
        icon: 'fa fa-h-square',
        url: 'clinical_consent_history',
        breadcrumb: "clinical_consent_history",
        auto_crud: true,
        check_permission: false,
        showMenu: false
    },
    {
        name: 'menu.consent_history',
        resource: 'consent_history',
        icon: 'fa fa-h-square',
        url: 'consent_history',
        breadcrumb: "consent_history",
        auto_crud: true,
        check_permission: false,
        showMenu: false
    },
    {
        "name": "Patient Feedback Pending",
        "resource": "patient_feedback_pending",
        "icon": "fa fa-h-square",
        "url": "patient_feedback_pending",
        "auto_crud": true,
        "breadcrumb": "My Feeds",
        "check_permission": false,
        "showMenu": false
      },
    {
        "name": "menu.Feedback",
        "icon": "fa fa-building-o",
        "data": {
            "nav_url": "feedback_format_m"
        },
        "children": [
            {
                name: "menu.ip_feedback",
                resource: "ip_feedback_format",
                icon: "fa fa-file-text-o",
                url: "ip_feedback_format",
                auto_crud: true,
                breadcrumb: "Feed Back",
                check_permission: false
            },
            {
                name: "menu.op_feedback",
                resource: "op_feedback_format",
                icon: "fa fa-file-text-o",
                url: "op_feedback_format",
                auto_crud: true,
                breadcrumb: "Feed Back",
                check_permission: false
            },
            {
                name: "menu.er_feedback",
                resource: "er_admit_feedback_format",
                icon: "fa fa-file-text-o",
                url: "er_admit_feedback_format",
                auto_crud: true,
                breadcrumb: "Feed Back",
                check_permission: false
            },
            {
                name: "menu.er_feedback",
                resource: "er_discharged_feedback_format",
                icon: "fa fa-file-text-o",
                url: "er_discharged_feedback_format",
                auto_crud: true,
                breadcrumb: "Feed Back",
                check_permission: false
            },
            {
                name: "menu.dc_feedback",
                resource: "dc_admit_feedback_format",
                icon: "fa fa-file-text-o",
                url: "dc_admit_feedback_format",
                auto_crud: true,
                breadcrumb: "Feed Back",
                check_permission: false
            },
            {
                name: "menu.dc_feedback",
                resource: "dc_discharged_feedback_format",
                icon: "fa fa-file-text-o",
                url: "dc_discharged_feedback_format",
                auto_crud: true,
                breadcrumb: "Feed Back",
                check_permission: false
            },
            {
                name: "menu.dc_feedback",
                resource: "dc_feedback_format",
                icon: "fa fa-file-text-o",
                url: "dc_feedback_format",
                auto_crud: true,
                breadcrumb: "Feed Back",
                check_permission: false
            },
            {
                name: "menu.ward_round_feedback",
                resource: "ward_round_feedback_format",
                icon: "fa fa-file-text-o",
                url: "ward_round_feedback_format",
                auto_crud: true,
                breadcrumb: "Feed Back",
                check_permission: false
            },
            {
                name: "menu.er_feedback",
                resource: "er_feedback_format",
                icon: "fa fa-file-text-o",
                url: "er_feedback_format",
                auto_crud: true,
                breadcrumb: "Feed Back",
                check_permission: false
            }, {
                name: 'menu.macros',
                resource: 'macros',
                icon: 'fa fa-h-square',
                url: 'macros',
                breadcrumb: "Macro",
                auto_crud: true
            },
            {
                name: 'menu.macros',
                resource: 'user_defined_macro',
                icon: 'fa fa-h-square',
                url: 'user_defined_macro',
                breadcrumb: "Macro",
                auto_crud: true
            },
        ]
    }
]
